import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { transNum } from '../../../func/func';
import { useNavigate } from 'react-router-dom';
import { isLogin } from '../../../utils/auth';
import Tags from '../../../func/Tags';
import { isAfterTime } from '../../../utils/eventTime';

const Banner = [
  // {
  //   img: '/assets/images/modal/Modal-presentation.png',
  //   link: '/엔플랫폼_설명회',
  // },
  {
    img: '/assets/images/modal/Modal-seminar.png',
    link: 'https://naver.me/F6nE6oJo',
  },
  {
    img: '/assets/images/modal/Modal-lucky.png',
    link: '/promotion/땅집고옥션-럭키-이벤트',
  },
  {
    img: '/assets/images/modal/Modal-local.png',
    link: '/payment/plan',
  },

  {
    img: '/assets/images/modal/game_mo_Banner.png',
    link: '/game',
  },
  {
    img: '/assets/images/modal/Modal-nplatform.png',
    link: 'https://nplatform.ai/',
  },
  {
    img: '/assets/images/modal/Modal-free-3.png',
    link: '/promotion/3일-무료체험-이벤트',
  },
];

const EventModal = ({ setOpenModal }: any) => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);

  const filterBanner = () => {
    // if (isAfterTime()) {
    //   return Banner.filter((_, i) => i !== 1);
    // }
    return Banner;
  };

  const banners = filterBanner();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [banners]);

  return (
    // <Container
    //   onClick={(e) => {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     setOpenModal(false);
    //   }}
    // >
    <Inner>
      <img
        src={banners[currentIndex].img}
        alt=""
        style={{
          width: '100%',

          borderTopLeftRadius: '24px',
          borderTopRightRadius: '24px',
        }}
        onClick={() => {
          const link = banners[currentIndex]?.link;
          if (!link) return;

          if (link.startsWith('http')) {
            window.open(link, '_blank');
          } else {
            navigate(link);
          }
        }}
      />
      <NumberIndicator>
        <span>{currentIndex + 1}</span> / {banners.length}
      </NumberIndicator>

      <ButtonBox>
        <CloseButton
          onClick={() => {
            sessionStorage.setItem(
              'event_modal',
              `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`,
            );
            setOpenModal(false);
          }}
          today
        >
          오늘 하루 보지 않기
        </CloseButton>
        <CloseButton
          onClick={() => {
            setOpenModal(false);
          }}
        >
          닫기
        </CloseButton>
      </ButtonBox>
    </Inner>
  );
};

export default EventModal;

const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const Inner = styled.div`
  position: relative;
  width: 100%;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  display: flex;
  flex-direction: column;
  filter: blur(0);
  -webkit-filter: blur(0);
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
`;

const ButtonBox = styled.div`
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
`;

const CloseButton = styled.button<{ today?: boolean }>`
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: ${({ today }) => (today ? '#37383C9C' : '#222222')};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  border: none;
  height: 100%;
  background-color: transparent;
`;

const NumberIndicator = styled.div`
  position: absolute;
  right: 16px;
  bottom: 72px;
  background-color: #0000008f;
  color: #ffffff80;
  padding: 4px 10px;
  border-radius: 9999px;

  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;

  span {
    color: #ffffff;
  }
`;
